export * from './TextCounter';
